import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

const useStyle = makeStyles({
  textField: {
    backgroundColor: '#515b65',
    border: '1px solid #23282c',
    borderRadius: '.25rem',
    color: '#e4e7ea',
    fontSize: '.875rem',
    padding: '.375rem .75rem',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  },
})

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip)

const validateMaxAndMinValues = (value, { setValue, max, min }, setShowHelper) => {
  let valueValidate = value
  if (Number(value) < min) {
    valueValidate = min
    setShowHelper(`the value can not be less than ${min}`)
  } else if (Number(value) > max) {
    valueValidate = max
    setShowHelper(`the value can not be greater than ${max}`)
  } else {
    setShowHelper('')
  }

  setValue(valueValidate)
}

const InputNumber = ({ defaultValue, change, id, max, min }) => {
  const classes = useStyle()
  let initialValue = defaultValue
  if (!Number.isInteger(initialValue)) {
    initialValue = Number(initialValue.toFixed(2))
  }
  const [value, setValue] = useState(initialValue)
  const [textHelper, setShowHelper] = useState('')
  const propertyValue = {
    setValue,
    max,
    min,
  }

  const onBlur = event => {
    change(event.target)
    setShowHelper('')
  }

  return (
    <LightTooltip title={textHelper || ''} open={!!textHelper}>
      <TextField
        key={`${id}-textField`}
        value={value}
        onBlur={event => onBlur(event)}
        onChange={event =>
          validateMaxAndMinValues(event.target.value, propertyValue, setShowHelper)
        }
        id={id}
        type="number"
        margin="none"
        variant="outlined"
        InputProps={{
          maxLength: 10,
          autoComplete: 'off',
          classes: {
            input: classes.textField,
          },
        }}
      />
    </LightTooltip>
  )
}

InputNumber.defaultProps = {
  defaultValue: '',
  id: '',
  max: 999999999,
  min: 0,
}

export default InputNumber
